// extracted by mini-css-extract-plugin
module.exports = {"container":"links_container__3Sn2W","item":"links_item__13aKx","danger":"links_danger__3YURX"};